import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { z } from 'zod';
import { BlockCard } from '../lib/block-card.js';
import { InlineMarkdown } from '../lib/inline-markdown.js';
const KeyValuePairSchema = z
    .object({
    key: z.string(),
    value: z.string(),
})
    .strict();
export const KeyValuePropsSchema = z
    .object({
    title: z.string().optional(),
    pairs: z.array(KeyValuePairSchema),
})
    .strict();
/** Renders a `key_value` block. */
export function KeyValuePrimitive({ title, pairs }) {
    return (_jsx(BlockCard, { title: title, children: _jsx("dl", { className: "divide-y divide-border/60", children: pairs.map((pair, index) => (_jsxs("div", { className: "flex gap-4 py-1.5 text-sm", children: [_jsx("dt", { className: "w-32 flex-none text-muted-foreground", children: pair.key }), _jsx("dd", { className: "min-w-0 flex-1 font-medium tabular-nums text-foreground", children: _jsx(InlineMarkdown, { children: pair.value }) })] }, index))) }) }));
}
